import { calculateShippingCost, mapCountryToGroup, SHIPPING_RATES } from "../shippingRates";

export { calculateShippingCost };

declare global {
  interface Window {
    ekMarkets?: Record<string, boolean>;
  }
}

const MARKET_OPTIONS = [
  { value: "DE", label: "Versand nach DE" },
  { value: "AT", label: "Versand nach AT" },
  { value: "CH", label: "Versand nach CH" },
  { value: "EU", label: "Versand nach EU" },
];

export const getInitialCountry = (): string => {
  try {
    const stored = localStorage.getItem("selectedCountry");
    if (stored && SHIPPING_RATES[stored]) return stored;
  } catch {
    // storage unavailable — fall through to market detection
  }
  const detected = ((window as { Shopify?: { country?: string } }).Shopify?.country || "").toUpperCase();
  return mapCountryToGroup(detected);
};

export const formatPrice = (priceEur: number): string =>
  new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(priceEur);

/** Fills the country select with the enabled markets (same gate as the cart drawer). */
export const populateCountrySelect = (select: HTMLSelectElement): void => {
  const markets = window.ekMarkets || { DE: true, AT: true, CH: true, EU: true };
  select.innerHTML = "";
  for (const option of MARKET_OPTIONS) {
    if (!markets[option.value]) continue;
    const el = document.createElement("option");
    el.value = option.value;
    el.textContent = option.label;
    select.appendChild(el);
  }
  const initial = getInitialCountry();
  if (markets[initial]) select.value = initial;
};

export const persistCountry = (country: string): void => {
  try {
    localStorage.setItem("selectedCountry", country);
  } catch {
    // ignore
  }
};
